/* Kendal Hill homepage: one-tap add to cart + Request a product button. */
(function () {
  if (window.__khhBound) return;
  window.__khhBound = true;

  function add(btn) {
    var label = btn.querySelector('.khh-add__label');
    var original = label.textContent;
    btn.classList.add('is-busy');
    label.textContent = 'Adding…';
    var item = { id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1 };
    var bundleUrl = btn.getAttribute('data-bundle');
    /* School bundles: send the default contents chosen on the product page, exactly as that page would. */
    var ready = !bundleUrl ? Promise.resolve(item) : fetch(bundleUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inputs = doc.querySelectorAll('.kh-bundle-contents input[name^="properties["]');
        var props = {};
        for (var k = 0; k < inputs.length; k++) {
          var n = inputs[k].getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, '');
          if (n) props[n] = inputs[k].value;
        }
        if (Object.keys(props).length) item.properties = props;
        return item;
      });
    ready
      .then(function (it) {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [it] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        label.textContent = 'Added ✓';
        /* The theme's own event: updates the cart count and opens the mini cart. */
        btn.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button: btn, variant: null, quantity: 1, productAdded: true } }));
        setTimeout(function () { btn.classList.remove('is-added'); label.textContent = original; }, 2200);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        label.textContent = original;
        var link = btn.closest('.khh-card') && btn.closest('.khh-card').querySelector('.khh-card__title');
        if (link) window.location.href = link.href;
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var btn = t.closest('[data-khh-add]');
    if (btn) { e.preventDefault(); add(btn); return; }
    var req = t.closest('[data-khh-request]');
    if (req) {
      e.preventDefault();
      var tab = document.querySelector('[data-khrt="open"]');
      if (tab) tab.click(); else window.location.href = '/pages/bring-it-to-bim';
    }
  });
})();
